export default from './InputForm';


/** WEBPACK FOOTER **
 ** ./app/components/inputForm/index.js
 **/